export default __webpack_public_path__ + "static/media/Log.d29d8012.svg";